import fetchApi from '../../../lib/fetchApi.ts';
import { SurveyItem } from '../types/index.ts'

export const getDoneSurveyAPI = async (): Promise<SurveyItem[]> => {
    const response = await fetchApi.get<SurveyItem[]>('/survey/done');
    return response;
};
